import { render, staticRenderFns } from "./writePlace.vue?vue&type=template&id=b6945338&scoped=true"
import script from "./writePlace.vue?vue&type=script&lang=js"
export * from "./writePlace.vue?vue&type=script&lang=js"
import style0 from "./writePlace.vue?vue&type=style&index=0&id=b6945338&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6945338",
  null
  
)

export default component.exports